import { useQuerySecondaryCategoryDetailHeader } from '../../models/useQuerySecondaryCategoryDetailHeader'

export interface IUseSecondaryCategoryDetailHeaderPresenterParams {
  /** Route param — the FS/Page owns routing context (ADR-9) */
  secondaryCategoryId: number
  /** False when another report config's header hook should fetch instead */
  enabled?: boolean
}

/**
 * Hook-only presenter (ADR-2): resolves the secondary category for BOTH
 * the orders and expenses detail breadcrumbs (BHV-022). The breadcrumb
 * shows `name` (Angular parity; `nameWithPrimaryCategory` remains
 * available on the entity if parity ever requires it).
 */
export const useSecondaryCategoryDetailHeaderPresenter = ({
  secondaryCategoryId,
  enabled = true,
}: IUseSecondaryCategoryDetailHeaderPresenterParams) => {
  const { secondaryCategory, isLoading } =
    useQuerySecondaryCategoryDetailHeader(secondaryCategoryId, enabled)

  return {
    data: {
      secondaryCategoryName: secondaryCategory?.name ?? null,
    },
    states: {
      isLoading,
    },
  }
}
